module.exports = __webpack_public_path__ + "img/personal-invite.789d885f.svg";